export enum NotificationType {
  JobProgressNotification = 'JobProgressNotification',
  JobResultNotification = 'JobResultNotification',
  BulkOperationJobResultNotification = 'BulkOperationJobResultNotification',
  BulkWorkflowAssignmentJobProgressNotification = 'BulkWorkflowAssignmentJobProgressNotification',
  BulkPublishJobProgressNotification = 'BulkPublishJobProgressNotification',
  BulkUploadDocumentJobResultNotification = 'BulUploadDocumentJobResultNotification',
  BulkUploadDocumentJobProgressNotification = 'BulkUploadDocumentJobProgressNotification',
}
